// Null-safe pickup check. A shipped order's shipping_method is effectively
// always present in prod, but a discarded/soft-deleted shipping_method can
// serialize as null; reading `.delivery_type` off it crashes the whole
// tracking page (order-history title/description builders). This guards it.
export const isPickupDelivery = (shippingMethod) => shippingMethod?.delivery_type === 'Pickup'
